import { AdminDashboardScreen } from '@features/admin/ui/AdminDashboardScreen'

export function DashboardPage() {
  return <AdminDashboardScreen />
}
